import React from 'react'
import Table from '@material-ui/core/Table'
import TableHead from '@material-ui/core/TableHead'
import TableBody from '@material-ui/core/TableBody'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import Typography from '@material-ui/core/Typography'
import { useIntl } from 'react-intl'
import InvestigatorsUsageRow from './InvestigatorsUsageRow'

export default ({ data }) => {
    const intl = useIntl()

    return (
        <div data-testid="sponsor-investigators-table" className="label-paper-inner" style={{ margin: '20px -32px 0' }} >
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell
                            data-testid="sponsor-investigators-investigator-name"
                            align='left'>
                            <Typography variant="caption">
                                {intl.formatMessage({ id: 'app.sponsor.investigatorsTable.investigatorHeader' }).toUpperCase()}
                            </Typography>
                        </TableCell>
                        <TableCell align='left'>
                            <Typography variant="caption"
                                data-testid="sponsor-investigators-cases-count"
                            >
                                {intl.formatMessage({ id: 'app.sponsor.investigatorsTable.casesCountHeader' }).toUpperCase()}
                            </Typography>
                        </TableCell>
                        <TableCell align='left'>
                            <Typography
                                data-testid="sponsor-investigators-sms-count"
                                variant='caption'>
                                {intl.formatMessage({ id: 'app.sponsor.investigatorsTable.smsCountHeader' }).toUpperCase()}
                            </Typography>
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data && data.map((user, index) =>
                        <InvestigatorsUsageRow data={user} key={index} />)
                    }
                </TableBody>
            </Table>
        </div>
    )
}